//@flow
import React from "react";

import type { Props as ContextMenu2Props } from "./";

export type MenuItemType = {
  onClick: Function,
  onMouseOver: Function,
  label: string,
  icon?: string,
  disabled?: boolean,
  hidden?: boolean,
  className?: string,
  children?: MenuItemType[] | React$Element<any>[],
  contextMenu?: ContextMenu2Props,
  disableOnClick?: boolean,
};

export function MenuItem(props: MenuItemType) {
  return (
    <div
      onMouseOver={props.onMouseOver}
      onClick={props.onClick}
      className={`menu-item ${props.disabled ? "disabled" : ""} ${props.hidden ? "hidden" : ""} ${
        props.disableOnClick ? "" : "clickable"
      } ${props.className || ""}`}
    >
      {props.icon && <span className="material-icons">{props.icon}</span>}
      {props.label && <span>{props.label}</span>}
      {!!props.children && props.children}
    </div>
  );
}
